import { PDF_GENERATION_ENDPOINT, SUPPORT_NOTIFICATION_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export const postReturnForm = async ({ body, isSupportNotifyEndpoint, }) => {
    const { data } = await Network.post(isSupportNotifyEndpoint ? SUPPORT_NOTIFICATION_ENDPOINT : PDF_GENERATION_ENDPOINT, body, {
        headers: {
            'Content-Type': 'application/pdf',
        },
        responseType: 'arraybuffer',
    });
    return data;
};
